var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTrainer)?_c('button',{staticClass:"zapping-pill",class:{ 'zapping-pill--light': !_vm.isDark, 'zapping-pill--locked': _vm.locked },attrs:{"type":"button"},on:{"click":_vm.onClick}},[_c('v-icon',{attrs:{"size":"14"}},[_vm._v(_vm._s(_vm.locked ? 'mdi-lock-outline' : 'mdi-flash'))]),_vm._v(" "+_vm._s(_vm.$t('common.zapping'))+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }